import React, { useState, useEffect } from "react";
import SwitchConNInput from "./fields/SwitchConNInput";
import SwitchConInput from "./fields/SwitchConInput";
import ListaToggleButton from "./fields/ListaToggleButton";

const Costruzione = (props) => {
  const [costruzione, setCostruzione] = useState(
    props.preventivo.costruzione || {
      title: "Costruzione",
      descr: "Sono compresi materiali fondamentali necessari per l'edificazione della struttura, escludendo qualsiasi decoro aggiuntivo specificatamente richiesto dal committente",

      // posa PAVIMENTI DI OGNI GENERE
      posaPavimento: {
        tipologia: "SwitchConNInput",
        titolo: "Posa pavimento di ogni genere esclusi bagni e cucina",
        descrizione: `Posa pavimento di ogni genere (parquet, gres, PVC) compresa colla`,
        valore: false,
        prezzoFinale: 0,
        valoriInput: [
          {
            nome: "Legno Parquet",
            descrizione: "Pavimento legno parquet",
            descQuantita: "mq",
            quantita: 0,
            prezzo: 40,
          },
          {
            nome: "Gres",
            descrizione: "Pavimento gres",
            descQuantita: "mq",
            quantita: 0,
            prezzo: 33,
          },
          {
            nome: "PVC",
            descrizione: "Pavimenti PVC",
            descQuantita: "mq",
            quantita: 0,
            prezzo: 17,
          },
        ],
      },
      // tavolati 8 spessore tavolatiMattone8x24x24
      tavolati8spessore: {
        tipologia: "SwitchConInput",
        titolo: "Costruzione parete con Mattoni con spessore 8 cm",
        descrizione:
          "Fornitura in opera di tavolato forati 8 x 24 x 24 cm eseguito con malta bastarda. Compresi gli oneri per la formazione di spalle, voltini, lesene, piani di lavoro interni, riquadratura aperture.",
        valore: false,
        descrizioneQuantita: "Metri quadri",
        descQuantita: "mq",
        quantita: 0,
        prezzo: 60,
      },
      // tavolati 12 spessore tavolatiMattone12x24x24
      tavolati12spessore: {
        tipologia: "SwitchConInput",
        titolo: "Costruzione parete con Mattoni con spessore 12 cm",
        descrizione:
          "Fornitura in opera di tavolato forati 12 x 24 x 24 cm eseguito con malta bastarda. Compresi gli oneri per la formazione di spalle, voltini, lesene, piani di lavoro interni, riquadratura aperture.",
        valore: false,
        descrizioneQuantita: "Metri quadri",
        descQuantita: "mq",
        quantita: 0,
        prezzo: 65,
      },
      // parete cartongesso
      pareteCartongesso: {
        tipologia: "SwitchConInput",
        titolo: "Costruzione parete in cartongesso",
        descrizione:
          "Costruzione di una parete di cartongesso. Compresi gli oneri per la formazione di spalle, voltini, lesene, piani di lavoro interni, riquadratura aperture.",
        valore: false,
        descrizioneQuantita: "Metri quadri",
        descQuantita: "mq",
        quantita: 0,
        prezzo: 65,
      },
      // sottofondo
      sottofondo: {
        tipologia: "SwitchConInput",
        titolo: "Costruzione sottofondo / massetto",
        descrizione:
          "Costruzione sottofondo in malta cementizia per permettere una migliore esecuzione degli impianti fino a uno spessore di 5 cm.",
        valore: false,
        descrizioneQuantita: "Metri quadri",
        descQuantita: "mq",
        quantita: 0,
        prezzo: 45,
      },
      // telaio porte
      telaioPorte: {
        tipologia: "SwitchConNInput",
        titolo: "Costruzione telaio e contro telaio porte interne",
        descrizione: `Costruzione di un telaio costituito da montanti verticali  e traversi orizzontalie installazione del controtelaio necessario per l'installazione della porta stessa`,
        valore: false,
        prezzoFinale: 0,
        valoriInput: [
          {
            nome: "Battenti",
            descrizione: "Numero porte battenti",
            descQuantita: "pezzo",
            quantita: 0,
            prezzo: 100,
          },
          {
            nome: "Scrigno",
            descrizione: "Numero porte scrigno",
            descQuantita: "pezzo",
            quantita: 0,
            prezzo: 250,
          },
          {
            nome: "Scomparsa",
            descrizione: "Numero porte Scomparsa",
            descQuantita: "pezzo",
            quantita: 0,
            prezzo: 100,
          },
        ],
      },
      // velette
      velette: {
        tipologia: "SwitchConInput",
        titolo: "Costruzione di velette",
        descrizione:
          "Costruzione velette di qualsiasi tipo, completi di struttura portante",
        valore: false,
        descrizioneQuantita: "Metri lineari",
        descQuantita: "ml",
        quantita: 0,
        prezzo: 60,
      },
      // zoccolino
      zoccolino: {
        tipologia: "SwitchConInput",
        titolo: "Posa zoccolino",
        descrizione:
          "Posa zoccolino di qualsiasi tipo (marmo, gres, legno, ...) compresa colla",
        valore: false,
        descrizioneQuantita: "Metri lineari",
        descQuantita: "ml",
        quantita: 0,
        prezzo: 8,
      },
      // controSoffitto
      controSoffitto: {
        tipologia: "SwitchConInput",
        titolo: "Costruzione controsoffitto ",
        descrizione: "Costruzione controsoffitto",
        valore: false,
        descrizioneQuantita: "Metri quadri",
        descQuantita: "mq",
        quantita: 0,
        prezzo: 60,
      },
      // intonacatura
      intonacatura: {
        tipologia: "SwitchConInput",
        titolo: "Intonacatura",
        descrizione:
          "Esecuzione di intonaco premiscelato  per interni su pareti restanti al netto delle pareti di nuova realizzazione.",
        valore: false,
        descrizioneQuantita: "Metri quadri",
        descQuantita: "mq",
        quantita: 0,
        prezzo:23 ,
      },
      // intonacatura
      rasatura: {
        tipologia: "SwitchConInput",
        titolo: "Rasatura",
        descrizione:
          "Esecuzione di rasatura  per interni su pareti restanti al netto delle pareti di nuova realizzazione.Finitura a gesso fine o civile, applicata per uno spessore non inferiore a 3 mm",
        valore: false,
        descrizioneQuantita: "Metri quadri",
        descQuantita: "mq",
        quantita: 0,
        prezzo: 18,
      },
      // imbiancatura
      imbiancatura: {
        tipologia: "SwitchConInput",
        titolo: "Imbiancatura",
        descrizione:
          "Preparazione delle superfici, Protezione di eventuali arredi e delle aree circostanti, scelta della vernice, applicazione della vernice marca Sikkens colore bianco",
        valore: false,
        descrizioneQuantita: "Metri quadri",
        descQuantita: "mq",
        quantita: 0,
        prezzo: 12,
      },
    }
  ); // fine json


  useEffect(() => {
    props.onChange(costruzione);
  }, [costruzione]);

  const divider = (
    <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
  );

  return (
    <>
      <div className="surface-ground px-1 py-1 md:px-4 md:py-4">
        <div className="text-900 font-medium text-900 text-xl mb-2">
          {costruzione.title}
        </div>
        <p className="m-0 mb-2 p-0 text-600 line-height-3 mr-3">
          {costruzione.descr}
        </p>
        <div className="surface-card p-4 shadow-2 border-round">
          <div className="grid formgrid p-fluid">
            {Object.keys(costruzione).map((key) => (
              <React.Fragment key={key}>
                {costruzione[key].tipologia === "SwitchConInput" && (
                  <>
                    <SwitchConInput
                      field={costruzione[key]}
                      onChange={(data) => {
                        setCostruzione({ ...costruzione, [key]: data });
                      }}
                    />
                    {divider}
                  </>
                )}
                {costruzione[key].tipologia === "SwitchConNInput" && (
                  <>
                    <SwitchConNInput
                      field={costruzione[key]}
                      onChange={(data) => {
                        setCostruzione({ ...costruzione, [key]: data });
                      }}
                    />
                    {divider}
                  </>
                )}
                {costruzione[key].tipologia === "ListaToggleButton" && (
                  <>
                    <ListaToggleButton
                      field={costruzione[key]}
                      onChange={(data) => {
                        setCostruzione({ ...costruzione, [key]: data });
                      }}
                    />
                    {divider}
                  </>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
export default Costruzione;
